import { css } from 'styled-components';
import token from 'styled-token';
import { SliderThumbMixin, SliderTrackMixin } from './SliderMixin';

// Styling based on:
// http://danielstern.ca/range.css/#/

var thumbsCSS = function thumbsCSS(props) {
  return token('Range.Thumb.boxShadow.focus', function (focusBoxShadow) {
    return css(["&::-webkit-slider-thumb{", " -webkit-appearance:none;margin-top:-11px;}&::-moz-range-thumb{", "}&::-ms-thumb{", " height:6px;margin-top:0;}&:focus-visible::-webkit-slider-thumb,&:active::-webkit-slider-thumb{box-shadow:", ";}&:focus-visible::-moz-range-thumb,&:active::-moz-range-thumb{box-shadow:", ";}@supports not selector(:focus-visible){&:focus::-webkit-slider-thumb{box-shadow:", ";}&:focus::-moz-range-thumb{box-shadow:", ";}}"], SliderThumbMixin(props), SliderThumbMixin(props), SliderThumbMixin(props), focusBoxShadow, focusBoxShadow, focusBoxShadow, focusBoxShadow);
  })(props);
};
var trackCSS = function trackCSS(props) {
  return token('Range.Track.width', function (width) {
    if (width === void 0) {
      width = '100%';
    }
    return css(["", " width:", ";"], SliderTrackMixin(props), width);
  })(props);
};
var tracksCSS = function tracksCSS(props) {
  return token({
    backgroundColor: 'Slider.trackBackgroundColor',
    borderRadius: 'Range.Tracks.borderRadius'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius;
    return css(["&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&::-moz-focus-outer{border:0;}&::-ms-track{", " background:transparent;border-color:transparent;color:transparent;}&::-ms-fill-lower{background:", ";border-radius:", ";}&::-ms-fill-upper{background:", ";border-radius:", ";}"], trackCSS(props), trackCSS(props), trackCSS(props), backgroundColor, borderRadius, backgroundColor, borderRadius);
  })(props);
};

/** @class RangeMixin */
/** @method */
export var RangeMixin = function RangeMixin(props) {
  return token({
    width: 'Range.width',
    marginX: 'Range.marginX',
    marginY: 'Range.marginY',
    border: 'Range.border',
    boxShadow: 'Range.boxShadow.default',
    focusBoxShadow: 'Range.boxShadow.focus',
    focusOutline: 'Range.outline.focus'
  }, function (_ref2) {
    var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$marginX = _ref2.marginX,
      marginX = _ref2$marginX === void 0 ? 0 : _ref2$marginX,
      _ref2$marginY = _ref2.marginY,
      marginY = _ref2$marginY === void 0 ? 11 : _ref2$marginY,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? 0 : _ref2$border,
      _ref2$boxShadow = _ref2.boxShadow,
      boxShadow = _ref2$boxShadow === void 0 ? 'none' : _ref2$boxShadow,
      _ref2$focusBoxShadow = _ref2.focusBoxShadow,
      focusBoxShadow = _ref2$focusBoxShadow === void 0 ? 'none' : _ref2$focusBoxShadow,
      _ref2$focusOutline = _ref2.focusOutline,
      focusOutline = _ref2$focusOutline === void 0 ? 'none' : _ref2$focusOutline;
    return css(["-webkit-appearance:none;height:auto;width:", ";margin:", "px ", "px;border:", ";box-shadow:", ";&:focus{box-shadow:", ";outline:", ";}", " ", ""], width, marginY, marginX, border, boxShadow, focusBoxShadow, focusOutline, thumbsCSS(props), tracksCSS(props));
  })(props);
};